
export const SEARCH_PAGE_ROUTE_NAME = 'search-page';
export type SearchPageRouteNameType = typeof SEARCH_PAGE_ROUTE_NAME;

export interface DynamicSearchPageServerSideProps<T = any> {
  routeName: SearchPageRouteNameType;
  props: T;
}